/**
 * Where tapping a notification goes (the payload's data, backend brief
 * section 29). Pure, for tests.
 *
 *   { type: 'message' | 'mention' | 'handover', space, conversationId, messageId?, threadRootId? }
 *   { type: 'todo', to }   anything from the bell's To do
 */
export function pathForPush(data) {
    const d = data || {};
    const enc = encodeURIComponent;
    if (d.type === 'todo' && typeof d.to === 'string' && d.to.charAt(0) === '/') return d.to;
    if (!d.conversationId) return '/messages';
    const space = ['team', 'clients', 'support'].indexOf(d.space) !== -1 ? d.space : 'team';
    const base = `/messages/${space}/${enc(d.conversationId)}`;
    if (d.threadRootId) return `${base}?t=${enc(d.threadRootId)}`;
    if (d.messageId) return `${base}?m=${enc(d.messageId)}`;
    return base;
}
